import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../services/api';
import { getSubdomainUsername, getUsernameSyncOnly } from '../../../utils/subdomain';
import { buildMediaUrl } from '../../../utils/mediaUrl';

const PublicClients = () => {
  const { username: urlUsername } = useParams();
  const subdomainUser = getSubdomainUsername();
  const cachedCustomDomainUser = getUsernameSyncOnly();
  const username = urlUsername || subdomainUser || cachedCustomDomainUser;

  const [clientsData, setClientsData] = useState({ section: null, clients: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await api.get(`/business/clients/public/${username}/`);
        // API returns array directly
        const clients = Array.isArray(res.data) ? res.data : (res.data.clients || res.data.items || []);
        setClientsData({
          section: res.data.section || {},
          clients: clients
        });
      } catch (err) {
        console.error('Error fetching clients:', err);
      } finally {
        setLoading(false);
      }
    };
    if (username) fetchClients();
  }, [username]);

  if (loading) {
    return (
      <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  const bgColor = clientsData.section?.background_color || '#1e293b';

  if (!clientsData.clients.length) {
    return (
      <div id="section-clients" style={{ padding: '4rem 2rem', textAlign: 'center', backgroundColor: bgColor }}>
        <p style={{ color: 'rgba(255,255,255,0.5)' }}>No clients available yet.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '4rem 2rem', backgroundColor: bgColor }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#fff', marginBottom: '0.5rem' }}>
            {clientsData.section?.title || 'Our Clients'}
          </h2>
          {clientsData.section?.subtitle && (
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.1rem' }}>
              {clientsData.section.subtitle}
            </p>
          )}
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '2rem',
          alignItems: 'center'
        }}>
          {clientsData.clients.map((client, index) => (
            <div
              key={client.id || index}
              style={{
                padding: '1.5rem',
                backgroundColor: 'rgba(255,255,255,0.05)',
                borderRadius: '1rem',
                textAlign: 'center',
                transition: 'transform 0.2s',
              }}
            >
              {client.logo ? (
                <img
                  src={buildMediaUrl(client.logo)}
                  alt={client.name}
                  style={{
                    maxWidth: '100px',
                    maxHeight: '60px',
                    objectFit: 'contain',
                    margin: '0 auto',
                    filter: 'brightness(0) invert(1)',
                    opacity: 0.8
                  }}
                />
              ) : (
                <span style={{ color: '#fff', fontWeight: '500' }}>{client.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PublicClients;
